export default {
  SET_CURRENCIES (state, currencies) {
    state.currencies = (currencies || [])
    state.loading = false
  },
  SET_CURRENCY_RATES (state, rates) {
    state.currencyRates = (rates || [])
    state.loading = false
  },
  SET_CURRENCY_RATES_ALL_STORE (state, rates) {
    state.currencyRatesAllStore = (rates || [])
    state.loading = false
  },
  SET_LOADING_CURRENCY (state, loading) {
    state.loading = loading
  }
}
